"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadAbTastyScript = exports.getScriptSrc = void 0;
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _react = require("react");
var _constants = require("../constants");
/**
 * Returns the AB Tasty script id based on the tenant and environment.
 * Example of generated url - https://try.abtasty.com/d7969c131a7cd1e6eae1663545c12f7e.js
 * @param tenant
 * @param environment
 */
const getScriptSrc = (tenant, environment) => {
  const key = tenant && environment ? `${tenant}_${environment}` : null;
  return key && _constants.AB_TASTY_SCRIPT_IDS[key] ? `${_constants.AB_TASTY_SCRIPT_URL}${_constants.AB_TASTY_SCRIPT_IDS[key]}.js` : null;
};

/**
 * Loads the AB Tasty script if the feature is enabled and have corresponding script with the current tenant and environment.
 */
exports.getScriptSrc = getScriptSrc;
const useLoadAbTastyScript = () => {
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const abTastyEnabled = isFeatureEnabled(_constants.TopAreaFeature.EnableABTasty);
  const {
    environment,
    tenant
  } = (0, _environment.useEnvironment)();
  (0, _react.useEffect)(() => {
    const scriptSrc = getScriptSrc(tenant, environment);
    if (abTastyEnabled && scriptSrc && !document.getElementById(_constants.AB_TASTY_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.type = 'didomi/javascript';
      script.dataset.vendor = 'ab-tasty';
      script.src = scriptSrc;
      script.async = true;
      script.id = _constants.AB_TASTY_SCRIPT_ID;
      document.body.append(script);
      return () => script.remove();
    }
    return undefined;
  }, [abTastyEnabled, environment, tenant]);
};
exports.useLoadAbTastyScript = useLoadAbTastyScript;